import React from 'react'

import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { t } from 'ttag'
import { INCLUDED_VALUE, SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import { updateSelectedFilters } from 'store/actions/filters'
import Button from 'components/ui/Button'
import FilterTitle from 'components/ui/FilterTitle'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import Dotdotdot from 'react-dotdotdot'
import CustomDropDownTreeSelect from 'components/ui/CustomDropdownTreeSelect'

function MacroRegionalStrategiesMultiSelect({
  type,
  filterData,
  values,
  title,
  onClose,
  showFilter,
  customTop,
  keyWord
}) {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters

  const selectedValues = filters.selectedFilters[currentSearchable][type][values[0]].map(
    option => ({
      label: option,
      id: option
    })
  )
  const options = filterData.map(option => {
    const parentOption = {
      label: option[keyWord],
      value: option.id,
      expanded: true
    }
    const selectedOption = selectedValues.filter(s => s.id === option.id)
    if (selectedOption.length > 0) {
      parentOption.checked = true
    } else if (option.id === INCLUDED_VALUE && selectedValues.length === 0) {
      parentOption.checked = true
    }
    return parentOption
  })

  const onChange = (currentNode, selectedNodes) => {
    let filterValue = selectedNodes.map(node => node.value)
    if (currentNode.value === INCLUDED_VALUE) {
      filterValue = []
    } else {
      filterValue = filterValue.filter(value => value !== INCLUDED_VALUE)
    }
    const data = {
      filterType: type,
      filterId: values[0],
      filterValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterRemove(filterId, filterValue, valueIsArray = false) {
    let resultingValue = null
    if (valueIsArray) {
      resultingValue = filters.selectedFilters[currentSearchable][type][filterId].filter(
        s => s.id !== filterValue.id || s !== filterValue
      )
    }
    const data = {
      filterType: type,
      filterId,
      filterValue: resultingValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function renderSelectedValues() {
    return values.map(value => {
      if (filters.selectedFilters[currentSearchable][type][value]) {
        const filterValue = filters.selectedFilters[currentSearchable][type][value]
        if (filterValue instanceof Array) {
          return filterValue.map(v => (
            <SelectedFilterContainer className="selected-filters" key={v}>
              <SelectedFilter>
                <FilterText title={v}>
                  <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{v.toUpperCase()}</Dotdotdot>
                </FilterText>
                <RemoveIcon
                  className="far fa-times"
                  onClick={() => handleFilterRemove(value, v, true)}
                />
              </SelectedFilter>
            </SelectedFilterContainer>
          ))
        }
      }
      return false
    })
  }

  return (
    <>
      <SearchFilter open={showFilter} customTop={customTop}>
        <FilterTitle>{title}</FilterTitle>
        <CustomDropDownTreeSelect data={options} onChange={onChange} />
        <Button size="medium" onClick={onClose}>
          {t`Close`}
        </Button>
      </SearchFilter>
      <div>{renderSelectedValues()}</div>
    </>
  )
}

MacroRegionalStrategiesMultiSelect.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  keyWord: PropTypes.string
}

export default MacroRegionalStrategiesMultiSelect
